import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Info, Heading, TextButton } from '@frontend/design-system';

type SettingsGroupProps = {
  children: React.ReactNode;
  title: string;
  actionLabel?: string;
  actionButtonTrackingId?: string;
  infoText?: string;
  disabledInfo?: boolean;
  disabledAction?: boolean;
  onActionClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  maxWidth?: number | string;
  condensed?: boolean;
};

export const SettingsGroup = ({
  children,
  title,
  disabledInfo,
  infoText,
  actionLabel,
  actionButtonTrackingId,
  onActionClick,
  disabledAction,
  maxWidth = 700,
  condensed = false,
}: SettingsGroupProps) => {
  return (
    <section
      css={[
        css`
          margin-bottom: ${theme.spacing(3)};
          width: 100%;
        `,
        { maxWidth },
      ]}
    >
      <header
        css={css`
          display: flex;
          align-items: center;
          margin-bottom: ${condensed ? '0' : theme.spacing(1)};
        `}
      >
        <Heading
          css={css`
            margin: 0;
          `}
          level={3}
        >
          {title}
        </Heading>
        {infoText && (
          <Info
            disabled={disabledInfo}
            color='light'
            css={css`
              display: flex;
              margin-left: ${theme.spacing(1)};
            `}
          >
            {infoText}
          </Info>
        )}
        {actionLabel && (
          <TextButton
            trackingId={actionButtonTrackingId}
            onClick={onActionClick}
            disabled={disabledAction}
            variant='rounded'
            css={css`
              margin-left: auto;
            `}
          >
            {actionLabel}
          </TextButton>
        )}
      </header>
      {children}
    </section>
  );
};
